import React from 'react';
import NotificationIcon from '../icons/NotificationIcon'; // Assuming you created this
import Logo from '../Branding/Logo'; // Import the Logo component
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom'; // Import Link
import defaultUserProfileImage from '../../assets/img/user-profile.jpg'; // Import default image
import { useNotificationContext } from '../../contexts/NotificationContext';

const TopNavbar = () => {
    const { logout, user, userId, role, getValidToken } = useAuth(); // Consume AuthContext
    const navigate = useNavigate();
    let profileImageUrl = defaultUserProfileImage;
    if (user && user.image) {
        profileImageUrl = user.image;
    }

    // Notification logic: useNotificationContext for unread notifications
    const { notifications } = useNotificationContext();
    const hasUnread = notifications && notifications.some(n => !n.read);

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom fixed-top py-3">
            <div className="container-fluid gap-3">
                <button className="navbar-toggler me-2" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasSidebar" aria-controls="offcanvasSidebar">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <a className="navbar-brand d-flex align-items-center" href="#">
                    <Logo />
                </a>

                <div className="d-flex align-items-center justify-content-md-end justify-content-between w-100">
                    <div className="dropdown me-5">
                        <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownUser" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <img src={profileImageUrl} alt={user?.name || 'Usuario'} className="rounded-circle me-2" style={{ width: '32px', height: '32px', objectFit: 'cover' }} />
                            {user?.name || 'Usuario'}
                        </a>
                        <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdownUser">
                            <li><Link className="dropdown-item" to="/profile">Perfil</Link></li>
                            <li><a className="dropdown-item" href="#">Configuración</a></li>
                            <li><hr className="dropdown-divider" /></li>
                            <li>
                                <button className="dropdown-item" onClick={() => {
                                    console.log('Logging out from TopNavbar...');
                                    logout();
                                    navigate('/login');
                                }}>Cerrar sesión</button>
                            </li>
                        </ul>
                    </div>
                    <Link to="/notifications" id="notificationsBellBtn" className="btn btn-link text-dark ms-2 p-0 pe-4" title="Ver notificaciones">
                        <NotificationIcon active={hasUnread} />
                    </Link>
                </div>
            </div>
        </nav>
    );
};

export default TopNavbar;